import {ReactComponent as LogoWhite } from "./svg/tincode-white.svg"
import authBg from "./jpg/auth-bg.jpg"
import homebanner from "./jpg/home-banner.jpg"
import noavatar from "./jpg/no-avatar.jpg"
import academylogo from "./png/academy-logo.png"


const Icon = {
    LogoWhite,
};
const image = {
    authBg,
    homebanner,
    noavatar,
    academylogo,
};

export { Icon, image };